var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bank-account-picker',{attrs:{"disabled":_vm.disabled,"addNew":_vm.addNew,"partBanks":_vm.partBankStore.partBanks,"selectedBankAccount":_vm.partBank,"showLabel":false},on:{"change":_vm.selected}})}
var staticRenderFns = []

export { render, staticRenderFns }